"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectRaw = exports.Select = void 0;
var React = require("react");
var react_1 = require("react");
var async_1 = require("react-select/async");
var react_select_1 = require("react-select");
var utils_1 = require("./utils");
var FormGroup_1 = require("./FormGroup");
exports.Select = React.memo(SelectRaw, function (prev, next) {
    return (utils_1.equalExcept(prev, next, "field", "map", "onSelect") &&
        prev.field.getValue() == next.field.getValue() &&
        prev.field.getError() == next.field.getError());
});
function SelectRaw(_a) {
    var field = _a.field, type = _a.type, topic = _a.topic, params = _a.params, _b = _a.map, map = _b === void 0 ? function (i) { return i; } : _b, options = _a.options, _c = _a.onSelect, onSelect = _c === void 0 ? function () { } : _c, style = _a.style, right = _a.right, placeholder = _a.placeholder, clear = _a.clear, indicatorSeparator = _a.indicatorSeparator, multi = _a.multi, disabled = _a.disabled, className = _a.className, id = _a.id, label = _a.label, other = __rest(_a, ["field", "type", "topic", "params", "map", "options", "onSelect", "style", "right", "placeholder", "clear", "indicatorSeparator", "multi", "disabled", "className", "id", "label"]);
    if (!options && !topic) {
        throw new Error("Either options or topic is required for Select");
    }
    var optionsArray = getOptionsArray(options, map);
    var ref = react_1.useRef();
    var _d = react_1.useState(false), loading = _d[0], setLoading = _d[1];
    var _e = react_1.useState([]), cachedOptions = _e[0], setCachedOptions = _e[1]; // cached options used to lookup option object from passed value
    var _f = react_1.useState([]), selected = _f[0], setSelected = _f[1];
    var _g = react_1.useState(""), inputValue = _g[0], setInputValue = _g[1];
    var selectedValues = field.getValue()
        ? multi
            ? field.getValue().split(",")
            : [field.getValue()]
        : [];
    function loadOptions(search) {
        return __awaiter(this, void 0, void 0, function () {
            var options, items;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = optionsArray;
                        if (!!options) return [3 /*break*/, 5];
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, topic.get(__assign(__assign({}, params), { search: search, values: search ? null : selectedValues }))];
                    case 2:
                        items = _a.sent();
                        options = items.map(map);
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        options = options.filter(function (o) {
                            return !search || o.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 || o.value == search;
                        });
                        _a.label = 6;
                    case 6:
                        setCachedOptions(options);
                        return [2 /*return*/, options];
                }
            });
        });
    }
    // set selected option
    react_1.useEffect(function () {
        var value = field.getValue();
        var selectedValues = value ? (multi ? value.split(",") : [value]) : [];
        var selected = cachedOptions.filter(function (o) { return selectedValues.indexOf(o.value) >= 0; });
        setSelected(selected);
        onSelect(selected);
    }, [cachedOptions, field.getValue()]);
    var initialRender = react_1.useRef(true);
    // on topic param change:
    // 1. reset value
    // 2. re-load options, updating cached options
    react_1.useEffect(function () {
        if (!initialRender.current) {
            // 2nd render
            field.setValue("");
        }
        else {
            initialRender.current = false;
        }
        // noinspection JSIgnoredPromiseFromCall
        loadOptions("");
    }, [JSON.stringify(params)]);
    function onChange(val) {
        if (Array.isArray(val) && !val.length) {
            // https://github.com/JedWatson/react-select/issues/2682
            val = "";
        }
        if (!val) {
            field.setValue("");
        }
        else {
            if (!Array.isArray(val)) {
                val = [val];
            }
            field.setValue(val.map(function (v) { return v.value; }).join(","));
        }
    }
    field.setFieldElement({
        type: type || (multi ? "stringList" : "string"),
        constraint: other,
        focus: function () { return ref.current && ref.current.focus(); },
        blur: function () { return ref.current.blur && ref.current.blur(); },
    });
    // key contains defaultOptions b/c we would like to update defaultOptions on topic params change
    return (React.createElement(FormGroup_1.FormGroup, { label: label, invalidFeedback: field.getError(), style: style },
        React.createElement(async_1.default, { className: ("select " + (className || "")).trim(), key: JSON.stringify(options), ref: ref, styles: __assign(__assign({}, styles), { indicatorSeparator: !indicatorSeparator
                    ? function () { return ({
                        display: "none",
                    }); }
                    : undefined }), menuPortalTarget: document.getElementById("popupTarget"), menuShouldBlockScroll: true, captureMenuScroll: false, classNamePrefix: "select", menuPlacement: "auto", defaultOptions: cachedOptions, components: {
                Option: function (props) { return React.createElement(HighlightingOption, __assign({}, props, { inputValue: inputValue })); },
            }, isLoading: loading, value: selected, loadOptions: loadOptions, onInputChange: function (val) { return setInputValue(val); }, onBlur: field.onBlur, onFocus: field.onFocus, onChange: onChange, placeholder: placeholder, isClearable: clear != null || !other.required, isMulti: multi, isDisabled: disabled, id: id }),
        right));
}
exports.SelectRaw = SelectRaw;
var styles = {
    control: function (_a) {
        var isDisabled = _a.isDisabled, isFocused = _a.isFocused;
        return ({});
    },
    valueContainer: function () { return ({
        display: "flex",
        flex: 1,
        overflow: "hidden",
    }); },
    input: function () { return ({}); },
};
var HighlightingOption = function (props) {
    var label = props.label, inputValue = props.inputValue, value = props.value, other = __rest(props, ["label", "inputValue", "value"]);
    return (React.createElement(react_select_1.components.Option, __assign({ label: label }, other), utils_1.highlight(label, inputValue)));
};
function getOptionsArray(options, map) {
    if (!options)
        return options;
    if (!Array.isArray(options)) {
        options = Object.keys(options || {}).map(function (value) { return ({
            value: value,
            label: options[value],
        }); });
    }
    options = options.map(function (o) {
        return typeof o == "string"
            ? {
                value: o,
                label: o,
            }
            : o;
    });
    options = options.map(map);
    return options;
}
